import React from 'react';
import Table from '@/common/components/Table';
import { Colors } from '@/common/colors/colors';
import { DetailSection, DetailTitle } from '../../callAnalysis.styles';

const HEADERS = ['Error', 'Evidence', 'Time'];

const CriticalErrorsSection = ({ criticalErrors }) => {
	if (!criticalErrors?.length) {
		return null;
	}

	const raws = criticalErrors.map((error) => (
		<tr key={error.error_id}>
			<td style={{ color: Colors.red, fontWeight: 600 }}>
				{error.label || error.error_id}
			</td>
			<td>{error.evidence || '—'}</td>
			<td>{error.timestamp || '—'}</td>
		</tr>
	));

	return (
		<DetailSection>
			<DetailTitle>Critical errors</DetailTitle>
			<Table className='styled-table' headers={HEADERS} raws={raws} />
		</DetailSection>
	);
};

export default CriticalErrorsSection;
